export default __webpack_public_path__ + "static/heroImage-d708f3d35504e976108e165089455be2.svg";